import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { scrollToSectionId } from "../../lib/scroll";
import { resolveMediaUrl } from "../../lib/api";
import { SocialLinks } from "./SocialLinks";

const HOME_LINKS = [
  { id: "servicios", label: "Servicios" },
  { id: "galeria", label: "Galería" },
  { id: "videos", label: "Videos" },
  { id: "cotizador", label: "Cotizador" },
  { id: "contacto", label: "Contacto" },
];

export const Navbar = ({ logoUrl, brandName, socialInstagram, socialFacebook }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goToSection = (id) => {
    setOpen(false);
    if (location.pathname === "/") {
      scrollToSectionId(id);
    } else {
      navigate(`/#${id}`);
    }
  };

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "backdrop-blur-xl bg-black/70 border-b border-white/10 py-3" : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        <button
          data-testid="navbar-logo-button"
          onClick={() => goToSection("inicio")}
          className="flex items-center gap-3 group"
        >
          {logoUrl && <img src={resolveMediaUrl(logoUrl)} alt={brandName} className="h-9 w-9 rounded-full object-cover" />}
          <span className="font-serif-display text-lg md:text-xl text-white tracking-wide group-hover:text-twp-gold transition-colors">
            {brandName}
          </span>
        </button>

        <nav className="hidden lg:flex items-center gap-10">
          {HOME_LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`navbar-link-${l.id}`}
              onClick={() => goToSection(l.id)}
              className="text-xs uppercase tracking-[0.2em] text-white/80 hover:text-twp-gold transition-colors"
            >
              {l.label}
            </button>
          ))}
          <SocialLinks instagram={socialInstagram} facebook={socialFacebook} className="pl-6 border-l border-white/15" />
        </nav>

        <button
          data-testid="navbar-mobile-toggle"
          className="lg:hidden text-white"
          onClick={() => setOpen(!open)}
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div data-testid="navbar-mobile-menu" className="lg:hidden mt-4 px-6 pb-6 flex flex-col gap-5 bg-black/90">
          {HOME_LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`navbar-mobile-link-${l.id}`}
              onClick={() => goToSection(l.id)}
              className="text-left text-sm uppercase tracking-[0.2em] text-white/80 hover:text-twp-gold transition-colors"
            >
              {l.label}
            </button>
          ))}
          <SocialLinks instagram={socialInstagram} facebook={socialFacebook} className="pt-2" />
        </div>
      )}
    </header>
  );
};
